// extracted by mini-css-extract-plugin
export var about = "index-module--about--32hpN";
export var bottom = "index-module--bottom--22T+q";
export var index = "index-module--index--Hg09G";
export var videoWrapper = "index-module--video-wrapper--yNI0K";